import MemberTypeItemNames from "./MemberTypeItemNames";

const AdministrativeAttrsConfirm = ({amd, fields, 
                                     memStatus, memType, memClass,
                                     memPost, memCommittee, memRepresentative,
                                     memPaymentMethod,
                                     viewMode, member}) => {
  const memStatusItems = [
      '',
      '申込',
      '仮入会',
      '審査中',
      '登録完了'
  ];

  const memTypeItems = [
      '',
      '正会員',
      '准会員',
      '正会員（准会員より移行）',
      '名誉会員'
  ];

  const memClassItems = [
      '',
      '現在会員',
      '退会',
      '退会（物故）',
      '退会（除名）'
  ];

  const memPaymentMethodItems = [
      '',
      '郵便振込',
      '自動引落'
  ];

  const memPostItems = [
      '理事長',
      '副理事長',
      '理事',
      '監事',
      '委員長'
  ];

  const memCommitteeItems = [
      '総務委員会',
      '財務委員会',
      '学術委員会',
      '編集委員会',
      '教育研修委員会',
      '資格審査委員会',
      '倫理・COI委員会',
      'オリンピック・パラリンピック等準備委員会',
      '国際委員会',
      '広報委員会'
  ];

  const memRepresentativeItems = [
      '代議員'
  ];
  const getSelectedItems = (items, labels) => {
    if (!items) return "";
    let arr = [];
    for (let i = 0; i < items.length; i++) {
	if (0 != items[i]) arr.push(labels[i]);
    }
    return arr.join();
  };

  const isShowOptions = () => {
    const mt = viewMode ? member.memType : memType;
    return (mt != 1 && mt != 2 && mt != 4 && mt != 5 && mt != 6);
  };

  const isOfficialMemType = () => {
    const mt = viewMode ? member.memType : memType;
    console.log('viewMode = ' + viewMode + ', mt = ' + mt);
    return (mt == 1 || mt == 2 || mt == 3 || mt == 9 || mt == 12 || mt == 13); 
  };
					     
  return (
    <>
      <h2>事務局使用欄</h2>
      <dl>
        <dt>会員番号</dt>
          <dd>{ viewMode ? (member.data == 'NotAssignedYet' ? '' : member.data) : (fields.loginId == 'NotAssignedYet' ? '' : fields.loginId) }&nbsp;</dd>
        <dt>入会申請日</dt>
        <dd>{ viewMode ? member.admissionRequestDate : fields.admissionRequestDate }&nbsp;</dd>
        <dt>入会日</dt>
        <dd>{ viewMode ? member.admissionDate : fields.admissionDate }&nbsp;</dd>
        <dt className="hideStatusRow">状態</dt>
        <dd className="hideStatusRow">{ viewMode ? memStatusItems[member.memStatus] : memStatusItems[memStatus] }&nbsp;</dd>
        <dt>会員種別</dt>
        <dd>{ viewMode ? MemberTypeItemNames[member.memType] : MemberTypeItemNames[memType] }&nbsp;</dd>
        <dt className={ amd == 'mgmt' ? '' : 'hideStatusRow' }>会員区分</dt>
        <dd className={ amd == 'mgmt' ? '' : 'hideStatusRow' }>{ viewMode ? memClassItems[member.memClass] : memClassItems[memClass] }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow' }>会員区分備考</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow' }>{ viewMode ? member.classRemarks : fields.classRemarks }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow'}>役職</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow'}>{ viewMode ? getSelectedItems(member.memPost, memPostItems) : getSelectedItems(memPost, memPostItems) }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow'}>委員会</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow'}>{ viewMode ? getSelectedItems(member.memCommittee, memCommitteeItems) : getSelectedItems(memCommittee, memCommitteeItems) }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow' }>役職・委員会（旧表記）</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow' }>{ viewMode ? member.postAndCommittee : fields.postAndCommittee }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow' }>委員会活動履歴</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow' }>{ viewMode ? member.committeeActiveHistories : fields.committeeActiveHistories }&nbsp;</dd>
        <dt className={ amd == 'mgmt' && isOfficialMemType() ? '' : 'hideStatusRow'}>代議員</dt>
        <dd className={ amd == 'mgmt' && isOfficialMemType() ? '' : 'hideStatusRow'}>{ viewMode ? getSelectedItems(member.memRepresentative, memRepresentativeItems) : getSelectedItems(memRepresentative, memRepresentativeItems) }&nbsp;</dd>
        <dt className={ isShowOptions() ? '' : 'hideStatusRow' }>代議員任期</dt>
        <dd className={ isShowOptions() ? '' : 'hideStatusRow' }>{ viewMode ? member.termOfRepresentative : fields.termOfRepresentative }&nbsp;</dd>
        <dt className={ amd == 'mgmt' && isOfficialMemType() ? '' : 'hideStatusRow'}>理事・理事任期</dt>
        <dd className={ amd == 'mgmt' && isOfficialMemType() ? '' : 'hideStatusRow'}>{ viewMode ? member.termOfDirective : fields.termOfDirective }&nbsp;</dd>
        <dt className={ 'hideStatusRow'}>准会員より正会員への変更日</dt>
        <dd className={ 'hideStatusRow'}>{ viewMode ? member.transitionDate : fields.transitionDate }&nbsp;</dd>
        <dt>学会賞</dt>
        <dd>{ viewMode ? member.academicAwards : fields.academicAwards }&nbsp;</dd>
        <dt>振込先情報</dt>
        <dd>{ viewMode ? member.accountPayable : fields.accountPayable }&nbsp;</dd>
        <dt>所属履歴</dt>
        <dd>{ viewMode ? member.teamHistories : fields.teamHistories }&nbsp;</dd>
        <dt>退会日</dt>
        <dd>{ viewMode ? member.unsubscribeDate : fields.unsubscribeDate }&nbsp;</dd>
        <dt>入金方法</dt>
        <dd>{ viewMode ? memPaymentMethodItems[member.memPaymentMethod] : memPaymentMethodItems[memPaymentMethod] }&nbsp;</dd>
        <dt>発送物</dt>
        <dd>{ viewMode ? member.shipments : fields.shipments }&nbsp;</dd>
        <dt>備考</dt>
        <dd>{ viewMode ? member.remarks : fields.remarks }&nbsp;</dd>
      </dl>
    </>
  );
}

export default AdministrativeAttrsConfirm;
